import { useQuery } from '@tanstack/react-query'

/**
 * Dashboard stats API response type
 */
export interface DashboardStats {
  overview: {
    searchesToday: number
    searchesWeek: number
    searchesMonth: number
    avgLatencyMs: number
    clickThroughRate: number
  }
  popularQueries: Array<{
    query: string
    count: number
  }>
  zeroResultQueries: Array<{
    query: string
    count: number
  }>
  recentSearches?: Array<{ query: string; timestamp: number }>
  store: {
    productCount: number
    categoryCount: number
    fitmentCount?: number
    lastSyncAt: number | null
  }
}

/**
 * Fetch dashboard analytics stats
 */
export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: async (): Promise<DashboardStats> => {
      const response = await fetch('/api/stats', {
        credentials: 'include',
      })

      if (!response.ok) {
        throw new Error('Failed to fetch stats')
      }

      return response.json()
    },
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Auto-refresh every minute
  })
}
